export default __webpack_public_path__ + "static/media/dragon-doge-logo.84e6ed7e.svg";